// ─── Business Contact ─────────────────────────────────────────
export const WHATSAPP_URL   = 'https://wa.me/601116281524';
export const PHONE_DISPLAY  = '+60 11-1628 1524';
export const EMAIL_DISPLAY  = 'ppbycw@gmail.com';

// ─── Operating Hours ──────────────────────────────────────────
export const HOURS_DISPLAY  = '12:00 PM – 2:00 AM';
export const HOURS_DAYS     = 'Monday – Sunday';

// ─── PS5 Game Library ─────────────────────────────────────────
export const PS5_GAMES = ['FC 25', 'UFC 5', 'Overcooked', 'NBA 2K24', 'Tekken 8'];
